/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ExperienceCompanyTypeDto = {
    Competitor: 'COMPETITOR',
    None: 'NONE',
    Orange: 'ORANGE',
    Partner: 'PARTNER',
} as const;

export type ExperienceCompanyTypeDto = typeof ExperienceCompanyTypeDto[keyof typeof ExperienceCompanyTypeDto];



